import { Action, isType } from "diy/redux/typedActions";
import StoreProvider from "diy/redux/StoreProvider";

import { open, close } from "diy/module-action-bar/index";

const siteAdmin: any = require('diy/site-admin/main/siteadmin');

// =====
// STATE
// =====
interface AppState {
    siteAdmin: SiteAdminState;
}

interface SiteAdminState {
    isShown: boolean;
}

const initialState: SiteAdminState = {
    isShown: true
};

// =======
// REDUCER
// =======
function reducer(
    state: SiteAdminState = initialState,
    action: Action<any>
): SiteAdminState {
    if (isType(action, close)) {
        return Object.assign({}, state, {
            isShown: true
        });
    }
    if (isType(action, open)) {
        return Object.assign({}, state, {
            isShown: false
        });
    }
    return state;
}

// ====================
// STATE CHANGE HANDLER
// ====================
function select(state: AppState): SiteAdminState {
    return state.siteAdmin;
}

function stateChangeHandler (currentState: SiteAdminState, previousState: SiteAdminState) {
    if (previousState.isShown !== currentState.isShown) {
        if (currentState.isShown) {
            siteAdmin.show();
        } else {
            siteAdmin.hide();
        }
    }
}
// ==============
// INITIALIZATION
// ==============
export function init(storeProvider: StoreProvider) {
    storeProvider.addReducer(reducer, "siteAdmin");
    storeProvider.watchStore(select, stateChangeHandler);
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/index.ts
 **/